const rankings = [
  { rank: 1, title: '台北娜娜直播间名场面合集', hot: '🔥 128.5万', tag: 'HOT' },
  { rank: 2, title: '玩偶姐姐最新回应全记录', hot: '🔥 96.3万', tag: 'NEW' },
  { rank: 3, title: '莫里秀轻量版吃瓜短视频精选', hot: '🔥 87.1万', tag: 'HOT' },
  { rank: 4, title: '网红直播翻车搞笑吃瓜瞬间', hot: '🔥 73.8万', tag: 'HOT' },
  { rank: 5, title: '吃瓜娱乐现场前线速递', hot: '🔥 61.2万', tag: 'NEW' },
  { rank: 6, title: '真人秀片段名场面大盘点', hot: '🔥 54.6万', tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          本周最受关注的吃瓜内容排名
        </p>
        <div className="max-w-3xl mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 px-4 md:px-6 py-4 border-b border-background-200/60 last:border-0 hover:bg-background-100 transition-colors cursor-pointer rounded-lg"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-extrabold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-300 text-foreground-900'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              {item.tag && (
                <span className={`px-2 py-0.5 rounded-full text-xs font-semibold flex-shrink-0 whitespace-nowrap ${
                  item.tag === 'HOT'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-accent-100 text-accent-700'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-500 flex-shrink-0 whitespace-nowrap">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}